import React, { Component } from 'react';
import Input from './Input';
import { Menu, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import Datepicker from './Datepicker';
import { UNLIMITED_DATE } from '../../constants/admin/settings';
import { msToTime, oneYearFromNowInMs, isUnlimited } from '../../lib/date.utils';

class DatepickerUnlimited extends Component {
    state = { showMenu: null, checked: 'none' };
    _handleClick = event => {
        this.setState({ showMenu: event.currentTarget });
    };
    _close = () => {
        this.setState({ showMenu: null, checked: 'none' });
    };
    _isUnlimited = () => {
        return isUnlimited(this.props.value);
    };
    _handleRadio = event => {
        this.setState({ checked: event.target.value });
        switch (event.target.value) {
            case 'unlimited':
                return this.props.onChange && this.props.onChange(UNLIMITED_DATE, this.props.name);
            case 'date':
                return this.props.onChange && this.props.onChange(oneYearFromNowInMs(), this.props.name);
            default:
                break;
        }
    };
    componentDidUpdate(prevProps, prevState) {
        if (!prevState.showMenu && this.state.showMenu) {
            if (this._isUnlimited()) {
                this.setState({ checked: 'unlimited' });
            } else if (this.props.value) {
                this.setState({ checked: 'date' });
            }
        }
    }
    render() {
        return (
            <React.Fragment>
                <Input
                    showErrorMessage={false}
                    label={this.props.label}
                    onClick={this._handleClick}
                    value={this._isUnlimited() ? 'Unlimited' : this.props.value ? msToTime(this.props.value) : ''}
                    theme={this.props.theme}
                    errorMessage={!this.props.value ? 'required' : ''}
                />
                <Menu onClose={this._close} anchorEl={this.state.showMenu} open={!!this.state.showMenu}>
                    <div className="ckp-datepicker-unlimited">
                        <RadioGroup
                            aria-label="position"
                            name="position"
                            value={this.state.value}
                            onChange={this.handleChange}
                            row
                        >
                            <FormControlLabel
                                control={
                                    <Radio
                                        onChange={this._handleRadio}
                                        checked={this.state.checked === 'unlimited'}
                                        value="unlimited"
                                    />
                                }
                                label="Unlimited"
                            />
                            <FormControlLabel
                                control={
                                    <Radio
                                        onChange={this._handleRadio}
                                        checked={this.state.checked === 'date'}
                                        value="date"
                                    />
                                }
                                label="Date"
                            />
                        </RadioGroup>
                        {this.state.checked === 'date' ? (
                            <Datepicker
                                name={this.props.name}
                                value={!this.props.value || this._isUnlimited() ? '' : this.props.value}
                                onChange={this.props.onChange}
                            />
                        ) : null}
                    </div>
                </Menu>
            </React.Fragment>
        );
    }
}

export default DatepickerUnlimited;



// WEBPACK FOOTER //
// ./src/components/forms/DatepickerUnlimited.js